import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ResidentAccessOnMyHub } from "@/consts/ResidentAccessOnMyHub";
import { ResidentStatus } from "@/enums/ResidentStatus";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import moment from "moment";
import * as firebase from "firebase/app";
import { mapState } from "vuex";
import { residentsFileHeaders } from "@/utils/importHalper";
import { defaultFacilityValues } from "@/consts/defaultFacilityValues";
import { EventLocationsMixin } from "@/mixins/EventLocations";
import { VeteranStatusEnum } from "@/enums/VeteranStatusEnum";
import { toTranslationKey } from "@/utils/stringFormat";
import { EventLocations } from "@/enums/EventLocations";
import { getRegionName } from "@/utils/functionsRegion";
import { convertFacilityDateFormatToCsvFormat, detectDateFormat } from "@/utils/dateTimeFormat";
import { DEFAULT_AVATAR_WHITE, DEFAULT_AVATAR_WHITE_200x200 } from "@/consts/default-avatar";
import { FamilyHubUserStatus } from "@/enums/FamilyHubUserStatus";

export default {
  name: "AdmitResidentsDialog",
  components: {
    ConfirmDlg,
    ValidationObserver,
    ValidationProvider
  },
  mixins: [EventLocationsMixin],
  props: {
    facility: {
      type: Object,
      default: () => ({ mediaApps: [] })
    },
  },
  data() {
    return {
      dialog: false,
      isManual: true,
      loading: false,
      csv: null,
      csvData: null,
      filename: null,
      csvFileName: "",
      isError: false,
      isInfo: false,
      errorContent: "",
      infoContent: "",
      importedResidentsNumber: 0,
      updatedResidentsNumber: 0,
      facilitiesDateFormats: [],
      facilitiesDateFormatsDisplay: '',
      csvResidents: [],
      csvHeaders: residentsFileHeaders,
      veteranStatuses: Object.values(VeteranStatusEnum).map(x => ({ text: toTranslationKey(x), value: x })),
      resident: {
        name: null,
        email: null,
        pname: null,
        phone: null,
        dob: moment().set('year', 1950).format('YYYY-MM-DD'),
        wingName: null,
        wingId: null,
        roomName: null,
        checkInTime: new Date().getDate(),
        accessesOnMyhub: ResidentAccessOnMyHub,
        isUsingOwnDevice: null,
        imageUrl: DEFAULT_AVATAR_WHITE,
        thumbnailUrl: DEFAULT_AVATAR_WHITE_200x200,
        address: null,
        isStaffCanLoginAsResident: null,
        isEnableStaffAppNotifications: null,
      },
      csvHeaderColumns: [],
      csvDowloadTemplateUrl: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/csv-templates%2FResident%20CSV%20import%20template.xlsx%20-%20SheetV5.csv?alt=media&token=98851130-705f-4362-b0b1-a126afde0bc0'
    }
  },
  computed: {
    ...mapState({
      facilitiesForOrg: state => (state as any).userModule.facilitiesForOrg,
      facility: state => (state as any).facilityModule.selectedFacility
    }),
    csvHeaderColumnsFamilyMembers() {
      return this.csvHeaderColumns.filter(x => x.includes("Family"))
    },
  },
  created() {
     this.$store.dispatch("getFacilitiesForOrg")
  },
  mounted(){
    this.isManual = this.facility.isEnableManuallyAddDeleteResidents === true
    this.resident.isStaffCanLoginAsResident = this.facility?.isStaffCanLogInOnBehalfOfResident || false 
    this.resident.isEnableStaffAppNotifications = this.facility?.isEnabledStaffAppNotificationsForAllResidents || false
  },
  methods: {
    async admitResident() {
      const form = this.$refs.admitResidentForm as any;

      const validated = form.validate();

      if (!validated) return

      if (this.resident.email && this.resident.email.length) {

        this.resident.email = this.resident.email.trim().toLowerCase()

        const isExists = await this.checkIfResidentEmailExists(this.resident.email);

        if (isExists) {
          this.$refs.observer.setErrors({ Email: [this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.EmailAlreadyExists']] });
          return
        }
      }

      this.loading = true

      const dateOfBirth = moment(this.resident.dob).set({ hour: 0, minute: 0 })

      const resident: any = {
        name: this.resident.name,
        pname: null,
        phone: this.resident.phone,
        roomName: this.resident.roomName,
        wingId: this.resident.wingId,
        wingName: this.resident.wingName,
        refId: null,
        mediaAppOverrides: this.facility.mediaApps || [],
        accessesOnMyhub: this.resident.accessesOnMyhub,
        imageUrl: this.resident.imageUrl,
        thumbnailUrl: this.resident.thumbnailUrl,
        status: ResidentStatus.ActiveResident,
        checkInTime: this.resident.checkInTime,
        unreadNotifications: 0,
        staffAccess: true,
        familyHubUsers: [],
        familyHubUsersIds: [],
        isUsingOwnDevice: this.resident.isUsingOwnDevice,
        socialClubs: [],
        isShowOnMyhub: true,
        isDefaultToTV: true,
        facilityId: this.facility.id,
        dateOfBirth: dateOfBirth.toDate(),
        dob: dateOfBirth.format('YYYY-MM-DD'),
        isVeteran: this.resident.isVeteran || null,
        veteranStatus: this.resident.veteranStatus || null,
        email: this.resident.email,
        address: this.resident.address || "",
        isStaffCanLoginAsResident: this.resident?.isStaffCanLoginAsResident || false,
        isEnableStaffAppNotifications: this.resident?.isEnableStaffAppNotifications || false,
        isDeparted: this.resident.isDeparted || false,
      };

      if (this.resident.pname && this.resident.pname.length) {
        await this.$refs.ConfirmDlg.open(null, this.$t('ResidentsView.ThisWillReplaceTheResidentsNameOnTheirTabletText', { preferredName: this.resident.preferredName }), false, '', { noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'], yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Save'] })
          .then(response => {
            if (response && response.agree) {
              resident.pname = this.resident.pname
            }
          })
      }

      await this.$store.dispatch('admitResident', resident);
      await this.$store.dispatch("getResidentsShortData");

      this.loading = false

      this.close()
    },
    async mapCsvDataToObjects(csvData) {

      this.loading = true

      for (let i = 0; i < csvData.length; i++) {
        let residentName = ''
        try {
          const raw = csvData[i]
          const facilityName = this.getRawValues(raw).facility
          const facility = this.facilitiesForOrg.find(x => x.name == facilityName)

          if (facility) {
            residentName = this.getRawValues(raw).residentName
            let departedDateTime = null
            let admissionDateTime = null
            let dobDateTime = null
            const preferredName = this.getRawValues(raw).preferredName
            const residentCode = this.getRawValues(raw).residentCode
            const bed = this.getRawValues(raw).bed
            const wing = this.getRawValues(raw).wing
            const dobString = this.getRawValues(raw).dob
            const admissionDateString = this.getRawValues(raw).admissionDate
            const departedDateString = this.getRawValues(raw).discharged
            const isDeparted = this.getRawValues(raw).isDeparted
            const isUsingOwnDevice = this.getRawValues(raw).isUsingOwnDevice
            const isStaffCanLoginAsResident = this.getRawValues(raw).isStaffCanLoginAsResident
            const address = this.getRawValues(raw).address
            let familyMembers = this.getRawValues(raw).familyHubUsers
            let email = this.getRawValues(raw).email
            email = email ? email.trim().toLowerCase() : null

            const facilityDateFormat = convertFacilityDateFormatToCsvFormat(facility.dateFormat)

            this.setFacilitiesDateFormats(facilityDateFormat)

            const dobMoment = moment(dobString, facilityDateFormat)

            if (dobMoment.isValid()) {
              dobDateTime = firebase.firestore.Timestamp.fromDate(dobMoment.toDate())
            }
            else {
              this.setError(this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.InvalidDob'].replace('[residentName]', residentName), true)
            }

            if (!detectDateFormat(dobString)?.includes(facilityDateFormat)) {
              this.setError(`${this.$t('AdmitResidentsDialog.ImportResidents.DateOfBirth.DateFormatShouldMatchTheFacilityFormat')}: <b>${facilityDateFormat}</b>`, true)
            }

            if (isDeparted === true && departedDateString.length) {
              const departedDateMoment = moment(departedDateString, facilityDateFormat)

              if (departedDateMoment.isValid()) {
                departedDateTime = firebase.firestore.Timestamp.fromDate(departedDateMoment.toDate())
              }
              else {
                this.setError(this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.InvalidDepartedDate'].replace('[residentName]', residentName), true)
              }

              if (!detectDateFormat(departedDateString)?.includes(facilityDateFormat)) {
                this.setError(`${this.$t('AdmitResidentsDialog.ImportResidents.DischargedDeceasedDate.DateFormatShouldMatchTheFacilityFormat')}: <b>${facilityDateFormat}</b>`, true)
              }

            } else if (isDeparted === true) {
              departedDateTime = firebase.firestore.Timestamp.fromDate(new Date())
            }

            if (admissionDateString.length) {
              const admissionDateMoment = moment(admissionDateString, facilityDateFormat)

              if (admissionDateMoment.isValid()) {
                admissionDateTime = firebase.firestore.Timestamp.fromDate(admissionDateMoment.toDate())
              }
              else {
                this.setError(this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.InvalidAdmissionDate'].replace('[residentName]', residentName), true)
              }

              if (!detectDateFormat(admissionDateString)?.includes(facilityDateFormat)) {
                this.setError(`${this.$t('AdmitResidentsDialog.ImportResidents.AdmissionDate.DateFormatShouldMatchTheFacilityFormat')}: <b>${facilityDateFormat}</b>`, true)
              }
            }

            if(familyMembers && familyMembers.length) {
              familyMembers = familyMembers.map((familyMember) => {
                return {
                  appStatus: 'pending',
                  email: familyMember.email,
                  facilityId: facility.id,
                  facilityName: facility.name,
                  financialEPOA: {
                    id: '',
                    status: familyMember.isFamilyEpoa.toLowerCase() === "true"
                  },
                  imageUrl: '',
                  isFinancialEPOA: familyMember.isFamilyEpoa.toLowerCase() === "true",
                  name: familyMember.name,
                  phoneNumber: '',
                  relationship: 'Other',
                  residentId: '',
                  residentIds: [],
                  residentName: residentName,
                  residents: [{
                    id: '',
                    name: ''
                  }],
                  status: isDeparted? FamilyHubUserStatus.Archived: FamilyHubUserStatus.Active,
                  unreadNotifications: 0,
                  invitedToFamilyApp: familyMember.isFamilyApp.toLowerCase() === "true",
                  isCanInvite: familyMember.isFamilyCanAdd.toLowerCase() === "true"
                }
              })
            }

            const createdDateTime = admissionDateTime || firebase.firestore.Timestamp.fromDate(new Date())

            const csvResident: any = {
              name: residentName,
              pname: preferredName,
              roomName: bed,
              wingId: null,
              wingName: wing,
              refId: residentCode,
              mediaAppOverrides: this.facility.mediaApps || [],
              accessesOnMyhub: this.resident.accessesOnMyhub,
              imageUrl: this.resident.imageUrl,
              thumbnailUrl: this.resident.thumbnailUrl,
              status: departedDateTime ? ResidentStatus.Departed : ResidentStatus.ActiveResident,
              checkInTime: this.resident.checkInTime,
              unreadNotifications: 0,
              staffAccess: true,
              familyHubUsers: familyMembers,
              familyHubUsersIds: [],
              isUsingOwnDevice: false,
              socialClubs: [],
              isShowOnMyhub: true,
              isDefaultToTV: true,
              facilityId: facility.id,
              facilityName: facility.name,
              dateOfBirth: dobDateTime,
              dob: dobMoment.format('YYYY-MM-DD'),
              isVeteran: false,
              veteranStatus: null,
              departedTime: departedDateTime,
              departedTimeDisplay: departedDateString,
              createdDateTime: createdDateTime,
              createdDateTimeDisplay: admissionDateString || moment(createdDateTime.seconds * 1000).format(facilityDateFormat),
              facilityDateFormat: this.facility.dateFormat || defaultFacilityValues.dateFormat,
              isFromCsv: true,
              csvFileName: this.csvFileName,
              dateOfBirthDisplay: dobString,
              refOrigin: 'ResHub',
              address: address,
              isStaffCanLoginAsResident: isStaffCanLoginAsResident,
              isDeparted: isDeparted,
            }

            if (this.facility.isEnableResidentOwnDevice === true && (isUsingOwnDevice === true || isUsingOwnDevice === false)) {
              csvResident.isUsingOwnDevice = isUsingOwnDevice
              csvResident.email = email
            }

            if (!this.csvResidents.some(x => (residentCode?.length > 0 && x.refId === residentCode) || (email?.length > 0 && x.email === email))) {
              this.csvResidents.push(csvResident)
            }
            else {
              console.error(`Found copy of resident. refId: ${residentCode} ; email: ${email}`)
            }
          }
          else {
            this.setInfo(
              this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.FacilityNotFoundText'].replace('[facilityName]', facilityName));
          }
        } catch (error) {
          this.setError(
            this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.ResidentHasInvalidData'].replace('[residentName]', residentName))
          throw new Error(`mapCsvDataToObjects() Unable to map residents csv record/s. filename: ${this.csvFileName}. Error merrage: ${error}`);
        }
      }

      this.loading = false
    },
    async importResidents() {
      this.loading = true;
      const ids = [];
      const batchArray = [];
      const familyMembers = [];
      batchArray.push(firebase.firestore().batch());
      let operationCounter = 0;
      let batchIndex = 0;
      this.importedResidentsNumber = 0
      this.updatedResidentsNumber = 0

      const allWings = (await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
        orgId: this.$store.state.authModule.currentFacilityData.orgId,
        collectionName: 'eventLocations',
        conditions: [{ property: 'type', condition: '==', value: EventLocations.Wing }]
      })).data.data

      for (let i = 0; i < this.csvResidents.length; i++) {
        operationCounter++;
        const csvResident = this.csvResidents[i]
        const csvResidentFamilyMembers = this.csvResidents[i]?.familyHubUsers

        delete csvResident.createdDateTimeDisplay
        delete csvResident.departedTimeDisplay
        delete csvResident.dateOfBirthDisplay
        delete csvResident.familyHubUsers
        delete csvResident.familyHubUsersIds

        try {
          const residentRef = firebase.firestore().collection('residents').doc();

          const existingResidentSnap = await firebase.firestore().collection('residents').where('facilityId', '==', csvResident.facilityId)
            .where('refId', '==', csvResident.refId).get()

          const existingResident: any = existingResidentSnap.size ? { id: existingResidentSnap.docs[0].id, ...existingResidentSnap.docs[0].data() } : null

          const existingWing = csvResident.wingName?.length > 0 ? allWings.find(x => x.name.toLowerCase() === csvResident.wingName.toLowerCase() && x.facilityId === csvResident.facilityId): null

          if (csvResident.wingName?.length > 0 && !existingWing) {
            const wing = {
              name: csvResident.wingName,
              type: EventLocations.Wing,
              facilityId: csvResident.facilityId,
              isFromCsv: true,
              csvFileName: this.csvFileName
            }
            const res = await firebase.firestore().collection("eventLocations").add(wing)
            csvResident.wingId = res.id
            allWings.push(wing)
            console.log(`Addded wind: ${csvResident.wingName} for facility: ${csvResident.facilityName}`)
          }
          else if (existingWing){
            csvResident.wingId = existingWing.id
          }

          if (existingResident) {
            const existingResidentRef = firebase.firestore().collection('residents').doc(existingResident.id)

            const updateData = {}
            let isUpdate = false
            if (csvResident.name != existingResident.name) {
              updateData['name'] = csvResident.name
              isUpdate = true
            }
            if (csvResident.pname != existingResident.pname) {
              updateData['pname'] = csvResident.pname
              isUpdate = true
            }
            if (csvResident.roomName != existingResident.roomName) {
              updateData['roomName'] = csvResident.roomName
              isUpdate = true
            }
            if (csvResident.wingName != existingResident.wingName) {
              updateData['wingName'] = csvResident.wingName
              updateData['wingId'] = allWings.find(x => x.name.toLowerCase() === csvResident.wingName.toLowerCase() && x.facilityId === csvResident.facilityId)?.id || null
              isUpdate = true
            }

            if (csvResident.isUsingOwnDevice != existingResident.isUsingOwnDevice) {
              updateData['isUsingOwnDevice'] = csvResident.isUsingOwnDevice
              isUpdate = true
            }

            if (!this.isDatesTheSame(csvResident.dateOfBirth, existingResident.dateOfBirth)) {
              updateData['dateOfBirth'] = csvResident.dateOfBirth
              updateData['dob'] = csvResident.dob
              isUpdate = true
            }

            if (!this.isDatesTheSame(csvResident.createdDateTime, existingResident.createdDateTime)) {
              updateData['createdDateTime'] = csvResident.createdDateTime
              isUpdate = true
            }

            if (!this.isDatesTheSame(csvResident.departedTime, existingResident.departedTime)) {
              updateData['departedTime'] = csvResident.departedTime
              updateData['status'] = ResidentStatus.Departed
              isUpdate = true
            }

            if (csvResident.status != existingResident.status) {
              updateData['status'] = csvResident.status
              isUpdate = true
            }

            if (csvResident.email != existingResident.email) {
              updateData['email'] = csvResident.email
              isUpdate = true
            }

            if (isUpdate === true) {
              batchArray[batchIndex].update(existingResidentRef, updateData)
              console.log(`update resident ${csvResident.name}`, updateData)
              this.updatedResidentsNumber++;
            }
          }
          else {
            console.log('add resident ' + csvResident.name)
            delete csvResident.facilityDateFormat
            delete csvResident.isDeparted
            batchArray[batchIndex].set(residentRef, csvResident)
            this.importedResidentsNumber++;
          }


          if (operationCounter === 300) {
            console.log(`batchArray.push(${batchArray.length})`)
            batchArray.push(firebase.firestore().batch());
            batchIndex++;
            operationCounter = 0;
          }

          ids.push(residentRef.id);

          if(csvResidentFamilyMembers.length) {
            if (existingResident) {
              csvResidentFamilyMembers.forEach(familyMember => {
                familyMember.residentId = existingResident.id;
                familyMember.residentIds.push(existingResident.id)
              });
            } else {
              csvResidentFamilyMembers.forEach(familyMember => {
                familyMember.residentId = residentRef.id;
                familyMember.residentIds.push(residentRef.id)
              });
            }

            for(const familyMember of csvResidentFamilyMembers) {
              familyMembers.push(familyMember)
            }
          }
        } catch (error) {
          console.error('batch set error: ', error);
          this.$toast.open({ message: this.$i18n.messages[this.$i18n.locale]["AdmitResidentsDialog.UnhandledErrorUnableToImportResidents"], type: 'error' })
        }
      }

      const departedResidents = this.csvResidents.filter(x => x.status === ResidentStatus.Departed).map(x => x.name).join('<br>')
      let dialogResponse = true

      if (departedResidents.length) {
        dialogResponse = (await this.$refs.ConfirmDlg.open(null, this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.DepartQuestionText'].replace('[departedResidents]', departedResidents), false)).agree
      }

      if (dialogResponse) {
        try {
          for (let index = 0; index < batchArray.length; index++) {
            const batch = batchArray[index]
            if (batch && batch.Ed && batch.Ed.length) {
              console.log(`batch[${index}].commit(${batch.Ed.length})`)
            }
            await batch.commit()
          }

          const promises = [];

          for (let index = 0; index < familyMembers.length; index++) {
            const promise = this.$store.dispatch('importFamilyHubUser', familyMembers[index]);
            promises.push(promise)
          }

          Promise.all(promises).then(() => {
            console.log("FINISHED FAMILY MEMBERS")
          })
        } catch (error) {
          console.error('batch commit error: ', error)
          this.$toast.open({ message: this.$i18n.messages[this.$i18n.locale]["AdmitResidentsDialog.UnhandledErrorUnableToImportResidents"], type: 'error' })
          this.loading = false;
          return;
        }

        let message = ''
        let type = 'success'

        if (this.importedResidentsNumber > 0) {
          message = `Imported ${this.importedResidentsNumber} resident${this.importedResidentsNumber > 1 ? 's' : ''}. ${this.updatedResidentsNumber > 0 ? '</br>' : ''}`
        }

        if (this.updatedResidentsNumber > 0) {
          message += `Updated ${this.updatedResidentsNumber} resident${this.updatedResidentsNumber > 1 ? 's' : ''}.`
        }

        if (!this.importedResidentsNumber && !this.updatedResidentsNumber) {
          type = 'info'
          message = this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.TheSystemIsUptoDateText']
        }

        this.$toast.open({ message: message, type: type })

        if (this.importedResidentsNumber > 0 || this.updatedResidentsNumber > 0) {
          await this.$store.dispatch("getResidentsShortData");
        }
        this.close()
      }
      else {
        this.loading = false;
      }
    },
    setFacilitiesDateFormats(format) {
      if (!this.facilitiesDateFormats.some(x => x === format)) {
        this.facilitiesDateFormats.push(format)
      }
      this.facilitiesDateFormatsDisplay = this.facilitiesDateFormats.join(', ')
    },
    async checkIfResidentEmailExists(emailAddress) {
      const isExists = await this.$store.dispatch('checkIfResidentEmailExists', {
        emailAddress: emailAddress
      })
      return isExists;
    },
    isDatesTheSame(csvDepartedDateTime, residentDepartedDateTime) {
      if (!csvDepartedDateTime && !residentDepartedDateTime) return true

      return csvDepartedDateTime && residentDepartedDateTime && moment(moment(csvDepartedDateTime.seconds * 1000).format('YYYY-MM-DD'))
        .isSame(moment(residentDepartedDateTime.seconds * 1000).format('YYYY-MM-DD'))
    },
    isVeteranChange(value) {
      if (!value) {
        this.resident.veteranStatus = null
      }
    },
    onSelectWing(id) {
      const wing = this.residentWings.find(x => x.id === id)

      if (!wing) return

      this.resident.wingId = wing.id
      this.resident.wingName = wing.name
    },
    async open() {
      this.dialog = true
      this.isManual = true
    },
    close() {
      this.dialog = false;
      this.filename = null;
      this.csvFileName = '';
      this.csv = null;
      this.csvData = null;
      this.loading = false;
      this.csvResidents = []
      this.facilitiesDateFormats = []
      this.facilitiesDateFormatsDisplay = ''
      this.resident.name = null
      this.resident.pname = null
      this.resident.dob = moment().set('year', 1950).format('YYYY-MM-DD')
      this.resident.email = null
      this.resident.wingName = null
      this.resident.wingId = null
      this.resident.roomName = null
      this.resident.isUsingOwnDevice = false
      this.resident.isStaffCanLoginAsResident = null
      this.resident.isEnableStaffAppNotifications = null
      this.$refs.admitResidentForm.reset()
      this.clearError()
      this.clearInfo()
    },
    onLoadFile(e) {
      if (!e || !e.currentTarget || !this.$papa || !this.$papa.parse) return

      const file = e.currentTarget.files[0]

      this.filename = file.name

      this.$papa.parse(file, {
        header: true,
        complete: this.onComplete,
        skipEmptyLines: true
      })
    },
    async onComplete(results, file) {
      this.clearError()
      this.clearInfo()
      this.csvHeaderColumns = results.meta.fields;

      if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
        const message = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseUploadaCSVFile'];
        this.setError(message);
        return false;
      }

      if (!this.isCsvColumnsValid(results)) {
        const message = this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.ImportResidents.MissingColumnText'].replace('[csvDowloadTemplateUrl]', this.csvDowloadTemplateUrl)
        this.setError(message)
        return false;
      }
      const isCsvDataValidResult = this.isCsvDataValid(results)
      if (!isCsvDataValidResult.isValid) {
        const message = this.$i18n.messages[this.$i18n.locale]['AdmitResidentsDialog.SomeOfYourColumnsHaveMissingDataText'] + '<br><br>';
        this.setError(`${message} ${isCsvDataValidResult.errors.join('<br>')}`)
        return false;
      }

      this.csvData = results.data;
      this.csvFileName = file.name
      await this.mapCsvDataToObjects(this.csvData)
      this.csv = results;
    },
    isManualChange(e) {
      if (e === true) {
        this.filename = null;
        this.csvFileName = '';
        this.csv = null;
        this.csvData = null;
        this.clearError()
      } else if (e === false) {
        this.$refs.admitResidentForm.reset()
        this.isManual = false
      }
      this.loading = false
    },
    isCsvDataValid(results) {
      const response = {isValid: false, errors: []}
      const invalidRows = results.data.filter((raw, index) => {
        const values = this.getRawValues(raw);
        const invalidColumns = [];
    
        if (!values.residentName) invalidColumns.push('residentName');
        if (!values.facility) invalidColumns.push('facility');
        if (!values.dob) invalidColumns.push('dob');
        if (!values.bed) invalidColumns.push('bed');
        if (!values.wing) invalidColumns.push('wing');
        if (this.facility.isEnableResidentOwnDevice === true && values.isUsingOwnDevice === true && !values.email) {
          invalidColumns.push('email');
        }

        if(values.familyHubUsers && values.familyHubUsers?.length) {
          values.familyHubUsers.forEach((familyMember, index) => {
            if(!familyMember.name) {
              invalidColumns.push(this.csvHeaders.familyName.replace('[index]', index + 1));
            }

            if(!familyMember.email) {
              invalidColumns.push(this.csvHeaders.familyEmail.replace('[index]', index + 1));
            }

            if(!familyMember.isFamilyEpoa) {
              invalidColumns.push(this.csvHeaders.familyEpoa.replace('[index]', index + 1));
            }

            if(!familyMember.isFamilyApp) {
              invalidColumns.push(this.csvHeaders.familyApp.replace('[index]', index + 1));
            }

            if(!familyMember.isFamilyCanAdd) {
              invalidColumns.push(this.csvHeaders.familyCanAdd.replace('[index]', index + 1));
            }
          })
        }
    
        if (invalidColumns.length > 0) {
          console.log(`Invalid row: ${index + 2}. Invalid columns:`, invalidColumns);
          response.errors.push(`Invalid row: ${index + 2}. Invalid column${invalidColumns.length>1?'s':''}: ${invalidColumns.join(', ')}.`)
        }
    
        return invalidColumns.length > 0;
      });
    
      if (invalidRows.length > 0) {
        console.log('Invalid rows:', invalidRows);
      }

      response.isValid = invalidRows.length === 0
    
      return response;
    },    
    isCsvColumnsValid(results) {
      const invalidFields = results.meta.fields.filter(f =>
        !(
          f.includes(this.csvHeaders.facility) ||
          f.includes(this.csvHeaders.residentName) ||
          f.includes(this.csvHeaders.preferredName) ||
          f.includes(this.csvHeaders.residentCode) ||
          f.includes(this.csvHeaders.dob) ||
          f.includes(this.csvHeaders.admissionDate) ||
          f.includes(this.csvHeaders.discharged) ||
          f.includes(this.csvHeaders.bed) ||
          f.includes(this.csvHeaders.wing) ||
          f.includes(this.csvHeaders.isDeparted) ||
          (this.facility.isEnableResidentOwnDevice === true ? f.includes(this.csvHeaders.isUsingOwnDevice) : true) ||
          f.includes(this.csvHeaders.isUsingOwnDevice) ||
          f.includes(this.csvHeaders.email) ||
          f.includes(this.csvHeaders.address) ||
          f.includes(this.csvHeaders.isStaffCanLoginAsResident) ||
          f.includes(this.csvHeaders.familyName.replace('[index]', f.match(/\b\d+\b/)[0])) ||
          f.includes(this.csvHeaders.familyEmail.replace('[index]', f.match(/\b\d+\b/)[0])) ||
          f.includes(this.csvHeaders.familyEpoa.replace('[index]', f.match(/\b\d+\b/)[0])) ||
          f.includes(this.csvHeaders.familyApp.replace('[index]', f.match(/\b\d+\b/)[0])) ||
          f.includes(this.csvHeaders.familyCanAdd.replace('[index]', f.match(/\b\d+\b/)[0]))
        )
      );
    
      if (invalidFields.length > 0) {
        console.log('Invalid fields:', invalidFields);
        return false;
      }
    
      return true;
    },
    getRawValues(raw) {
      const data = {
        facility: '',
        residentName: '',
        preferredName: null,
        residentCode: '',
        dob: '',
        admissionDate: '',
        isDeparted: undefined,
        isUsingOwnDevice: undefined,
        discharged: '',
        bed: '',
        wing: '',
        email: '',
        address: '',
        familyHubUsers: [],
        isStaffCanLoginAsResident: undefined
      }

      for (const key of Object.keys(raw)) {
        const value = raw[key] && typeof raw[key] === 'string' ? raw[key].trim() : raw[key]

        if (key.toLowerCase().includes(this.csvHeaders.facility.toLowerCase())) {
          data.facility = value
        } else if (key.toLowerCase() == this.csvHeaders.residentName.toLowerCase()) {
          data.residentName = value
        } else if (key.toLowerCase() == this.csvHeaders.preferredName.toLowerCase()) {
          data.preferredName = value
        } else if (key.toLowerCase() == this.csvHeaders.residentCode.toLowerCase()) {
          data.residentCode = value || null
        } else if (key.toLowerCase() == this.csvHeaders.dob.toLowerCase()) {
          data.dob = value
        } else if (key.toLowerCase() == this.csvHeaders.admissionDate.toLowerCase()) {
          data.admissionDate = value
        } else if (key.toLowerCase() == this.csvHeaders.discharged.toLowerCase()) {
          data.discharged = value
        } else if (key.toLowerCase() == this.csvHeaders.bed.toLowerCase()) {
          data.bed = value
        } else if (key.toLowerCase() == this.csvHeaders.wing.toLowerCase()) {
          data.wing = value
        } else if (key.toLowerCase() == this.csvHeaders.email.toLowerCase()) {
          data.email = value
        } else if (key.toLowerCase() == this.csvHeaders.address.toLowerCase()) {
          data.address = value
        } else if (key.includes(this.csvHeaders.isDeparted)) {
          data.isDeparted = (value.toLowerCase() === 'y') ? true : value.toLowerCase() === 'n' ? false : undefined
        } else if (key.includes(this.csvHeaders.isUsingOwnDevice)) {
          data.isUsingOwnDevice = (value.toLowerCase() === 'true') ? true : value.toLowerCase() === 'false' ? false : false
        } else if (key.includes(this.csvHeaders.isStaffCanLoginAsResident)) {
          data.isStaffCanLoginAsResident = (value.toLowerCase() === 'true') ? true : value.toLowerCase() === 'false' ? false : false
        } else if(
          (key.toLowerCase() == this.csvHeaders.familyName.replace('[index]', key.match(/\b\d+\b/)[0]).toLowerCase()) &&
          raw[this.csvHeaders.familyName.replace('[index]', key.match(/\b\d+\b/)[0])]
        ) {
          data.familyHubUsers.push({
            name: raw[this.csvHeaders.familyName.replace('[index]', key.match(/\b\d+\b/)[0])],
            email: raw[this.csvHeaders.familyEmail.replace('[index]', key.match(/\b\d+\b/)[0])] ?? undefined,
            isFamilyEpoa: raw[this.csvHeaders.familyEpoa.replace('[index]', key.match(/\b\d+\b/)[0])] ?? undefined,
            isFamilyApp: raw[this.csvHeaders.familyApp.replace('[index]', key.match(/\b\d+\b/)[0])] ?? undefined,
            isFamilyCanAdd: raw[this.csvHeaders.familyCanAdd.replace('[index]', key.match(/\b\d+\b/)[0])] ?? undefined
          });
        }
      }

      return data
    },
    clearError() {
      this.isError = false;
      this.errorContent = "";
    },
    clearInfo() {
      this.isInfo = false;
      this.infoContent = "";
    },
    setError(message, concat) {

      if (!this.errorContent.includes(message)) {
        if (concat === true) {
          this.errorContent += `<br> ${message}`;
        }
        else {
          this.errorContent = message;
        }
      }

      this.isError = true;
      this.filename = null;
      this.csvFileName = '';
      this.csv = null;
    },
    setInfo(message) {
      this.isInfo = true;
      this.infoContent = message;
    },
    csvBodyColumnsFamilyMembers(resident) {
      return resident.familyHubUsers.map(family => [family.name, family.email, family.isFinancialEPOA, family.invitedToFamilyApp, family.isCanInvite]).flat();
    }
  },
  watch: {
    ['facility.isStaffCanLogInOnBehalfOfResident'](value: boolean) {
      this.resident.isStaffCanLoginAsResident = value
    }
  }
}